export default __webpack_public_path__ + "static/media/guampower_customerservice_web.c084b844.jpg";